module.exports = __webpack_public_path__ + "img/251.1ef41901.png";